import ApprovedProposals from './ApprovedProposals';
export default ApprovedProposals;
